export interface GameMeta {
  id: string;
  path: string;
  title: string;
  developer: string;
  category: string;
  tags: string[];
  thumbnail: string;
  span: '1x1' | '2x2' | '3x3';
  rating?: string;
  gameplays?: string;
  released?: string;
  technology?: string;
  richTags?: { emoji: string; text: string; url: string; }[];
  descriptionHtml?: string;
  description?: string;
  instructions?: string;
  faqs?: { question: string, answer: string }[];
}

export const gamesRegistry: GameMeta[] = [
  {
    id: 'find_the_number',
    path: '/game/find-the-number',
    title: 'Find The Number',
    developer: 'Eternally Games',
    category: 'Puzzle',
    tags: ['casual', 'puzzle'],
    thumbnail: '/thumbnails/find-the-number.webp',
    span: '3x3',
    rating: '4.3 (44,491 votes)',
    gameplays: '1.3M',
    released: '2024',
    technology: 'HTML5',
    richTags: [
      { emoji: '🧩', text: 'Puzzle Games', url: '/categories' },
      { emoji: '🔥', text: 'Popular Games', url: '/categories' },
      { emoji: '📱', text: 'Mobile Ready', url: '/categories' }
    ],
    descriptionHtml: `
<p>Play Find The Number, a free puzzle game online where you challenge your mind and reflexes in an endless series of engaging levels. Experience beautiful graphics and smooth gameplay right in your browser!</p>
<p>Start your journey today, master the mechanics, and climb your way to the top. Whether you have 5 minutes or an hour, Find The Number is perfectly paced to keep you entertained.</p>
<h3>How to Play Find The Number? 🎮</h3>
<ul>
  <li>Understand the basic mechanics introduced in the first level.</li>
  <li>Use your mouse or touch screen to interact with the game elements.</li>
  <li>Complete the primary objectives before time or moves run out.</li>
  <li>Earn high scores by stringing together combos and playing efficiently.</li>
</ul>
<h3>Gameplay Workflow and Mechanics ⏱️</h3>
<ul>
  <li>Fast reaction times and careful planning are both rewarded.</li>
  <li>Make sure to analyze the board before making your first move.</li>
  <li>Smooth coordination ensures you don't make easily avoidable mistakes.</li>
</ul>
<h3>Unlock and Upgrade 💰</h3>
<ul>
  <li>Collect coins and gems as you complete levels.</li>
  <li>Use your earnings to unlock new cosmetic themes and powerups.</li>
  <li>Daily challenges provide huge bonus rewards!</li>
</ul>
<h3>Strategy Tips for Find The Number 📈</h3>
<ul>
  <li>Focus on efficiency rather than raw speed.</li>
  <li>Save your powerups for the hardest levels.</li>
  <li>Stay calm during high-pressure moments.</li>
  <li>Consistency and planning always outperform rushed actions.</li>
</ul>`
  },
  {
    id: 'ball_sort',
    path: '/game/ball-sort',
    title: 'Ball Sort',
    developer: 'Eternally Games',
    category: 'Puzzle',
    tags: ['casual', 'puzzle'],
    thumbnail: '/thumbnails/ball-sort.webp',
    span: '1x1',
    rating: '4.3 (30,547 votes)',
    gameplays: '5.7M',
    released: '2024',
    technology: 'HTML5',
    richTags: [
      { emoji: '🧩', text: 'Puzzle Games', url: '/categories' },
      { emoji: '🔥', text: 'Popular Games', url: '/categories' },
      { emoji: '📱', text: 'Mobile Ready', url: '/categories' }
    ],
    descriptionHtml: `
<p>Play Ball Sort, a free puzzle game online where you challenge your mind and reflexes in an endless series of engaging levels. Experience beautiful graphics and smooth gameplay right in your browser!</p>
<p>Start your journey today, master the mechanics, and climb your way to the top. Whether you have 5 minutes or an hour, Ball Sort is perfectly paced to keep you entertained.</p>
<h3>How to Play Ball Sort? 🎮</h3>
<ul>
  <li>Understand the basic mechanics introduced in the first level.</li>
  <li>Use your mouse or touch screen to interact with the game elements.</li>
  <li>Complete the primary objectives before time or moves run out.</li>
  <li>Earn high scores by stringing together combos and playing efficiently.</li>
</ul>
<h3>Gameplay Workflow and Mechanics ⏱️</h3>
<ul>
  <li>Fast reaction times and careful planning are both rewarded.</li>
  <li>Make sure to analyze the board before making your first move.</li>
  <li>Smooth coordination ensures you don't make easily avoidable mistakes.</li>
</ul>
<h3>Unlock and Upgrade 💰</h3>
<ul>
  <li>Collect coins and gems as you complete levels.</li>
  <li>Use your earnings to unlock new cosmetic themes and powerups.</li>
  <li>Daily challenges provide huge bonus rewards!</li>
</ul>
<h3>Strategy Tips for Ball Sort 📈</h3>
<ul>
  <li>Focus on efficiency rather than raw speed.</li>
  <li>Save your powerups for the hardest levels.</li>
  <li>Stay calm during high-pressure moments.</li>
  <li>Consistency and planning always outperform rushed actions.</li>
</ul>`
  },
  {
    id: 'water_sort',
    path: '/game/water-sort',
    title: 'Water Sort',
    developer: 'Eternally Games',
    category: 'Puzzle',
    tags: ['casual', 'puzzle'],
    thumbnail: '/thumbnails/water-sort.webp',
    span: '2x2',
    rating: '4.6 (46,933 votes)',
    gameplays: '4.0M',
    released: '2024',
    technology: 'HTML5',
    richTags: [
      { emoji: '🧩', text: 'Puzzle Games', url: '/categories' },
      { emoji: '🔥', text: 'Popular Games', url: '/categories' },
      { emoji: '📱', text: 'Mobile Ready', url: '/categories' }
    ],
    descriptionHtml: `
<p>Play Water Sort, a free puzzle game online where you challenge your mind and reflexes in an endless series of engaging levels. Experience beautiful graphics and smooth gameplay right in your browser!</p>
<p>Start your journey today, master the mechanics, and climb your way to the top. Whether you have 5 minutes or an hour, Water Sort is perfectly paced to keep you entertained.</p>
<h3>How to Play Water Sort? 🎮</h3>
<ul>
  <li>Understand the basic mechanics introduced in the first level.</li>
  <li>Use your mouse or touch screen to interact with the game elements.</li>
  <li>Complete the primary objectives before time or moves run out.</li>
  <li>Earn high scores by stringing together combos and playing efficiently.</li>
</ul>
<h3>Gameplay Workflow and Mechanics ⏱️</h3>
<ul>
  <li>Fast reaction times and careful planning are both rewarded.</li>
  <li>Make sure to analyze the board before making your first move.</li>
  <li>Smooth coordination ensures you don't make easily avoidable mistakes.</li>
</ul>
<h3>Unlock and Upgrade 💰</h3>
<ul>
  <li>Collect coins and gems as you complete levels.</li>
  <li>Use your earnings to unlock new cosmetic themes and powerups.</li>
  <li>Daily challenges provide huge bonus rewards!</li>
</ul>
<h3>Strategy Tips for Water Sort 📈</h3>
<ul>
  <li>Focus on efficiency rather than raw speed.</li>
  <li>Save your powerups for the hardest levels.</li>
  <li>Stay calm during high-pressure moments.</li>
  <li>Consistency and planning always outperform rushed actions.</li>
</ul>`
  },
  {
    id: 'cryptogram',
    path: '/game/cryptogram-quotes',
    title: 'Cryptogram Quotes',
    developer: 'Eternally Games',
    category: 'Word',
    tags: ['casual', 'word'],
    thumbnail: '/thumbnails/cryptogram.webp',
    span: '1x1',
    rating: '4.5 (30,681 votes)',
    gameplays: '8.5M',
    released: '2024',
    technology: 'HTML5',
    richTags: [
      { emoji: '📝', text: 'Word Games', url: '/categories' },
      { emoji: '🔥', text: 'Popular Games', url: '/categories' },
      { emoji: '📱', text: 'Mobile Ready', url: '/categories' }
    ],
    descriptionHtml: `
<p>Play Cryptogram Quotes, a free word game online where you challenge your mind and reflexes in an endless series of engaging levels. Experience beautiful graphics and smooth gameplay right in your browser!</p>
<p>Start your journey today, master the mechanics, and climb your way to the top. Whether you have 5 minutes or an hour, Cryptogram Quotes is perfectly paced to keep you entertained.</p>
<h3>How to Play Cryptogram Quotes? 🎮</h3>
<ul>
  <li>Understand the basic mechanics introduced in the first level.</li>
  <li>Use your mouse or touch screen to interact with the game elements.</li>
  <li>Complete the primary objectives before time or moves run out.</li>
  <li>Earn high scores by stringing together combos and playing efficiently.</li>
</ul>
<h3>Gameplay Workflow and Mechanics ⏱️</h3>
<ul>
  <li>Fast reaction times and careful planning are both rewarded.</li>
  <li>Make sure to analyze the board before making your first move.</li>
  <li>Smooth coordination ensures you don't make easily avoidable mistakes.</li>
</ul>
<h3>Unlock and Upgrade 💰</h3>
<ul>
  <li>Collect coins and gems as you complete levels.</li>
  <li>Use your earnings to unlock new cosmetic themes and powerups.</li>
  <li>Daily challenges provide huge bonus rewards!</li>
</ul>
<h3>Strategy Tips for Cryptogram Quotes 📈</h3>
<ul>
  <li>Focus on efficiency rather than raw speed.</li>
  <li>Save your powerups for the hardest levels.</li>
  <li>Stay calm during high-pressure moments.</li>
  <li>Consistency and planning always outperform rushed actions.</li>
</ul>`
  },
  {
    id: 'ludo',
    path: '/game/ludo-royale',
    title: 'Ludo Royale',
    developer: 'Eternally Games',
    category: 'Board',
    tags: ['casual', 'board'],
    thumbnail: '/thumbnails/ludo.webp',
    span: '2x2',
    rating: '4.1 (44,421 votes)',
    gameplays: '4.3M',
    released: '2024',
    technology: 'HTML5',
    richTags: [
      { emoji: '🎲', text: 'Board Games', url: '/categories' },
      { emoji: '🔥', text: 'Popular Games', url: '/categories' },
      { emoji: '📱', text: 'Mobile Ready', url: '/categories' }
    ],
    descriptionHtml: `
<p>Play Ludo Royale, a free board game online where you challenge your mind and reflexes in an endless series of engaging levels. Experience beautiful graphics and smooth gameplay right in your browser!</p>
<p>Start your journey today, master the mechanics, and climb your way to the top. Whether you have 5 minutes or an hour, Ludo Royale is perfectly paced to keep you entertained.</p>
<h3>How to Play Ludo Royale? 🎮</h3>
<ul>
  <li>Understand the basic mechanics introduced in the first level.</li>
  <li>Use your mouse or touch screen to interact with the game elements.</li>
  <li>Complete the primary objectives before time or moves run out.</li>
  <li>Earn high scores by stringing together combos and playing efficiently.</li>
</ul>
<h3>Gameplay Workflow and Mechanics ⏱️</h3>
<ul>
  <li>Fast reaction times and careful planning are both rewarded.</li>
  <li>Make sure to analyze the board before making your first move.</li>
  <li>Smooth coordination ensures you don't make easily avoidable mistakes.</li>
</ul>
<h3>Unlock and Upgrade 💰</h3>
<ul>
  <li>Collect coins and gems as you complete levels.</li>
  <li>Use your earnings to unlock new cosmetic themes and powerups.</li>
  <li>Daily challenges provide huge bonus rewards!</li>
</ul>
<h3>Strategy Tips for Ludo Royale 📈</h3>
<ul>
  <li>Focus on efficiency rather than raw speed.</li>
  <li>Save your powerups for the hardest levels.</li>
  <li>Stay calm during high-pressure moments.</li>
  <li>Consistency and planning always outperform rushed actions.</li>
</ul>`
  },
  {
    id: 'bubble_shooter',
    path: '/game/bubble-shooter',
    title: 'Bubble Shooter',
    developer: 'Eternally Games',
    category: 'Arcade',
    tags: ['casual', 'arcade'],
    thumbnail: '/thumbnails/bubble-shooter.webp',
    span: '1x1',
    rating: '4.7 (28,580 votes)',
    gameplays: '5.9M',
    released: '2024',
    technology: 'HTML5',
    richTags: [
      { emoji: '🕹️', text: 'Arcade Games', url: '/categories' },
      { emoji: '🔥', text: 'Popular Games', url: '/categories' },
      { emoji: '📱', text: 'Mobile Ready', url: '/categories' }
    ],
    descriptionHtml: `
<p>Play Bubble Shooter, a free arcade game online where you challenge your mind and reflexes in an endless series of engaging levels. Experience beautiful graphics and smooth gameplay right in your browser!</p>
<p>Start your journey today, master the mechanics, and climb your way to the top. Whether you have 5 minutes or an hour, Bubble Shooter is perfectly paced to keep you entertained.</p>
<h3>How to Play Bubble Shooter? 🎮</h3>
<ul>
  <li>Understand the basic mechanics introduced in the first level.</li>
  <li>Use your mouse or touch screen to interact with the game elements.</li>
  <li>Complete the primary objectives before time or moves run out.</li>
  <li>Earn high scores by stringing together combos and playing efficiently.</li>
</ul>
<h3>Gameplay Workflow and Mechanics ⏱️</h3>
<ul>
  <li>Fast reaction times and careful planning are both rewarded.</li>
  <li>Make sure to analyze the board before making your first move.</li>
  <li>Smooth coordination ensures you don't make easily avoidable mistakes.</li>
</ul>
<h3>Unlock and Upgrade 💰</h3>
<ul>
  <li>Collect coins and gems as you complete levels.</li>
  <li>Use your earnings to unlock new cosmetic themes and powerups.</li>
  <li>Daily challenges provide huge bonus rewards!</li>
</ul>
<h3>Strategy Tips for Bubble Shooter 📈</h3>
<ul>
  <li>Focus on efficiency rather than raw speed.</li>
  <li>Save your powerups for the hardest levels.</li>
  <li>Stay calm during high-pressure moments.</li>
  <li>Consistency and planning always outperform rushed actions.</li>
</ul>`
  },
  {
    id: 'sudoku',
    path: '/game/sudoku',
    title: 'Sudoku',
    developer: 'Eternally Games',
    category: 'Logic',
    tags: ['casual', 'logic'],
    thumbnail: '/thumbnails/sudoku.webp',
    span: '1x1',
    rating: '4.9 (9,219 votes)',
    gameplays: '6.5M',
    released: '2024',
    technology: 'HTML5',
    richTags: [
      { emoji: '🧠', text: 'Logic Games', url: '/categories' },
      { emoji: '🔥', text: 'Popular Games', url: '/categories' },
      { emoji: '📱', text: 'Mobile Ready', url: '/categories' }
    ],
    descriptionHtml: `
<p>Play Sudoku, a free logic game online where you challenge your mind and reflexes in an endless series of engaging levels. Experience beautiful graphics and smooth gameplay right in your browser!</p>
<p>Start your journey today, master the mechanics, and climb your way to the top. Whether you have 5 minutes or an hour, Sudoku is perfectly paced to keep you entertained.</p>
<h3>How to Play Sudoku? 🎮</h3>
<ul>
  <li>Understand the basic mechanics introduced in the first level.</li>
  <li>Use your mouse or touch screen to interact with the game elements.</li>
  <li>Complete the primary objectives before time or moves run out.</li>
  <li>Earn high scores by stringing together combos and playing efficiently.</li>
</ul>
<h3>Gameplay Workflow and Mechanics ⏱️</h3>
<ul>
  <li>Fast reaction times and careful planning are both rewarded.</li>
  <li>Make sure to analyze the board before making your first move.</li>
  <li>Smooth coordination ensures you don't make easily avoidable mistakes.</li>
</ul>
<h3>Unlock and Upgrade 💰</h3>
<ul>
  <li>Collect coins and gems as you complete levels.</li>
  <li>Use your earnings to unlock new cosmetic themes and powerups.</li>
  <li>Daily challenges provide huge bonus rewards!</li>
</ul>
<h3>Strategy Tips for Sudoku 📈</h3>
<ul>
  <li>Focus on efficiency rather than raw speed.</li>
  <li>Save your powerups for the hardest levels.</li>
  <li>Stay calm during high-pressure moments.</li>
  <li>Consistency and planning always outperform rushed actions.</li>
</ul>`
  },
  {
    id: 'chess',
    path: '/game/chess',
    title: 'Chess Royale',
    developer: 'Eternally Games',
    category: 'Board',
    tags: ['casual', 'board'],
    thumbnail: '/thumbnails/chess.webp',
    span: '2x2',
    rating: '4.6 (23,333 votes)',
    gameplays: '1.7M',
    released: '2024',
    technology: 'HTML5',
    richTags: [
      { emoji: '🎲', text: 'Board Games', url: '/categories' },
      { emoji: '🔥', text: 'Popular Games', url: '/categories' },
      { emoji: '📱', text: 'Mobile Ready', url: '/categories' }
    ],
    descriptionHtml: `
<p>Play Chess Royale, a free board game online where you challenge your mind and reflexes in an endless series of engaging levels. Experience beautiful graphics and smooth gameplay right in your browser!</p>
<p>Start your journey today, master the mechanics, and climb your way to the top. Whether you have 5 minutes or an hour, Chess Royale is perfectly paced to keep you entertained.</p>
<h3>How to Play Chess Royale? 🎮</h3>
<ul>
  <li>Understand the basic mechanics introduced in the first level.</li>
  <li>Use your mouse or touch screen to interact with the game elements.</li>
  <li>Complete the primary objectives before time or moves run out.</li>
  <li>Earn high scores by stringing together combos and playing efficiently.</li>
</ul>
<h3>Gameplay Workflow and Mechanics ⏱️</h3>
<ul>
  <li>Fast reaction times and careful planning are both rewarded.</li>
  <li>Make sure to analyze the board before making your first move.</li>
  <li>Smooth coordination ensures you don't make easily avoidable mistakes.</li>
</ul>
<h3>Unlock and Upgrade 💰</h3>
<ul>
  <li>Collect coins and gems as you complete levels.</li>
  <li>Use your earnings to unlock new cosmetic themes and powerups.</li>
  <li>Daily challenges provide huge bonus rewards!</li>
</ul>
<h3>Strategy Tips for Chess Royale 📈</h3>
<ul>
  <li>Focus on efficiency rather than raw speed.</li>
  <li>Save your powerups for the hardest levels.</li>
  <li>Stay calm during high-pressure moments.</li>
  <li>Consistency and planning always outperform rushed actions.</li>
</ul>`
  },
  {
    id: 'boggle',
    path: '/game/boggle',
    title: 'Boggle',
    developer: 'Eternally Games',
    category: 'Word',
    tags: ['casual', 'word'],
    thumbnail: '/thumbnails/boggle.webp',
    span: '1x1',
    rating: '4.4 (43,501 votes)',
    gameplays: '7.4M',
    released: '2024',
    technology: 'HTML5',
    richTags: [
      { emoji: '📝', text: 'Word Games', url: '/categories' },
      { emoji: '🔥', text: 'Popular Games', url: '/categories' },
      { emoji: '📱', text: 'Mobile Ready', url: '/categories' }
    ],
    descriptionHtml: `
<p>Play Boggle, a free word game online where you challenge your mind and reflexes in an endless series of engaging levels. Experience beautiful graphics and smooth gameplay right in your browser!</p>
<p>Start your journey today, master the mechanics, and climb your way to the top. Whether you have 5 minutes or an hour, Boggle is perfectly paced to keep you entertained.</p>
<h3>How to Play Boggle? 🎮</h3>
<ul>
  <li>Understand the basic mechanics introduced in the first level.</li>
  <li>Use your mouse or touch screen to interact with the game elements.</li>
  <li>Complete the primary objectives before time or moves run out.</li>
  <li>Earn high scores by stringing together combos and playing efficiently.</li>
</ul>
<h3>Gameplay Workflow and Mechanics ⏱️</h3>
<ul>
  <li>Fast reaction times and careful planning are both rewarded.</li>
  <li>Make sure to analyze the board before making your first move.</li>
  <li>Smooth coordination ensures you don't make easily avoidable mistakes.</li>
</ul>
<h3>Unlock and Upgrade 💰</h3>
<ul>
  <li>Collect coins and gems as you complete levels.</li>
  <li>Use your earnings to unlock new cosmetic themes and powerups.</li>
  <li>Daily challenges provide huge bonus rewards!</li>
</ul>
<h3>Strategy Tips for Boggle 📈</h3>
<ul>
  <li>Focus on efficiency rather than raw speed.</li>
  <li>Save your powerups for the hardest levels.</li>
  <li>Stay calm during high-pressure moments.</li>
  <li>Consistency and planning always outperform rushed actions.</li>
</ul>`
  },
  {
    id: 'four-in-a-row',
    path: '/game/four-in-a-row',
    title: 'Four in a Row',
    developer: 'Eternally Games',
    category: 'Board',
    tags: ['classic', 'board', 'multiplayer'],
    thumbnail: '/thumbnails/four-in-a-row.webp',
    span: '1x1',
    rating: '4.7 (2,109 votes)',
    gameplays: '850K',
    released: '2024',
    technology: 'HTML5',
    richTags: [
      { emoji: '🎲', text: 'Board Games', url: '/categories' },
      { emoji: '🤖', text: 'Play vs AI', url: '/categories' }
    ],
    descriptionHtml: `
<p>Play the classic Four in a Row game! Connect 4 of your colored chips in a row (horizontally, vertically, or diagonally) to win.</p>
<h3>Modes 🎮</h3>
<ul>
  <li><strong>Player vs AI:</strong> Test your skills against a smart Minimax algorithm!</li>
  <li><strong>Player vs Player:</strong> Play locally with a friend on the same device.</li>
</ul>`,
    faqs: []
  },
  {
    id: 'dots-connect',
    path: '/game/dots-connect',
    title: 'Dots Connect',
    developer: 'Eternally Games',
    category: 'Puzzle',
    tags: ['casual', 'puzzle'],
    thumbnail: '/thumbnails/dots-connect.webp',
    span: '1x1',
    rating: '4.6 (11,613 votes)',
    gameplays: '3.4M',
    released: '2024',
    technology: 'HTML5',
    richTags: [
      { emoji: '🧩', text: 'Puzzle Games', url: '/categories' },
      { emoji: '🔥', text: 'Popular Games', url: '/categories' },
      { emoji: '📱', text: 'Mobile Ready', url: '/categories' }
    ],
    descriptionHtml: `
<p>Play Dots Connect, a free puzzle game online where you challenge your mind and reflexes in an endless series of engaging levels. Experience beautiful graphics and smooth gameplay right in your browser!</p>
<p>Start your journey today, master the mechanics, and climb your way to the top. Whether you have 5 minutes or an hour, Dots Connect is perfectly paced to keep you entertained.</p>
<h3>How to Play Dots Connect? 🎮</h3>
<ul>
<h3>Gameplay Workflow and Mechanics ⏱️</h3>
<ul>
  <li>Fast reaction times and careful planning are both rewarded.</li>
  <li>Make sure to analyze the board before making your first move.</li>
  <li>Smooth coordination ensures you don't make easily avoidable mistakes.</li>
</ul>
<h3>Unlock and Upgrade 💰</h3>
<ul>
  <li>Collect coins and gems as you complete levels.</li>
  <li>Use your earnings to unlock new cosmetic themes and powerups.</li>
  <li>Daily challenges provide huge bonus rewards!</li>
</ul>
<h3>Strategy Tips for Dots Connect 📈</h3>
<ul>
  <li>Focus on efficiency rather than raw speed.</li>
  <li>Save your powerups for the hardest levels.</li>
  <li>Stay calm during high-pressure moments.</li>
  <li>Consistency and planning always outperform rushed actions.</li>
</ul>`
  },
  {
    id: 'emoji-connect',
    path: '/game/emoji-connect',
    title: 'Emoji Connect',
    developer: 'Eternally Games',
    category: 'Puzzle',
    tags: ['casual', 'puzzle'],
    thumbnail: '/thumbnails/emoji-connect.webp',
    span: '1x1',
    rating: '4.8 (8,932 votes)',
    gameplays: '1.2M',
    released: '2024',
    technology: 'HTML5',
    richTags: [
      { emoji: '🧩', text: 'Puzzle Games', url: '/categories' },
      { emoji: '🔥', text: 'Popular Games', url: '/categories' },
      { emoji: '📱', text: 'Mobile Ready', url: '/categories' }
    ],
    descriptionHtml: `
<p>Play Emoji Connect, a fun and vibrant puzzle game where you match similar emojis!</p>
<p>Start your journey today, master the mechanics, and climb your way to the top. Perfectly paced to keep you entertained.</p>
<h3>How to Play Emoji Connect? 🎮</h3>
<ul>
  <li>Connect matching emojis horizontally, vertically, or diagonally.</li>
  <li>Make long chains to rack up massive scores and trigger satisfying explosions.</li>
</ul>`,
    faqs: []
  },
  {
    id: 'color_switch',
    path: '/game/color-switch',
    title: 'Color Switch',
    developer: 'Eternally Games',
    category: 'Arcade',
    tags: ['casual', 'arcade'],
    thumbnail: '/thumbnails/color-switch.webp',
    span: '2x2',
    rating: '4.6 (43,825 votes)',
    gameplays: '9.1M',
    released: '2024',
    technology: 'HTML5',
    richTags: [
      { emoji: '🕹️', text: 'Arcade Games', url: '/categories' },
      { emoji: '🔥', text: 'Popular Games', url: '/categories' },
      { emoji: '📱', text: 'Mobile Ready', url: '/categories' }
    ],
    descriptionHtml: `
<p>Play Color Switch, a free arcade game online where you challenge your mind and reflexes in an endless series of engaging levels. Experience beautiful graphics and smooth gameplay right in your browser!</p>
<p>Start your journey today, master the mechanics, and climb your way to the top. Whether you have 5 minutes or an hour, Color Switch is perfectly paced to keep you entertained.</p>
<h3>How to Play Color Switch? 🎮</h3>
<ul>
  <li>Understand the basic mechanics introduced in the first level.</li>
  <li>Use your mouse or touch screen to interact with the game elements.</li>
  <li>Complete the primary objectives before time or moves run out.</li>
  <li>Earn high scores by stringing together combos and playing efficiently.</li>
</ul>
<h3>Gameplay Workflow and Mechanics ⏱️</h3>
<ul>
  <li>Fast reaction times and careful planning are both rewarded.</li>
  <li>Make sure to analyze the board before making your first move.</li>
  <li>Smooth coordination ensures you don't make easily avoidable mistakes.</li>
</ul>
<h3>Unlock and Upgrade 💰</h3>
<ul>
  <li>Collect coins and gems as you complete levels.</li>
  <li>Use your earnings to unlock new cosmetic themes and powerups.</li>
  <li>Daily challenges provide huge bonus rewards!</li>
</ul>
<h3>Strategy Tips for Color Switch 📈</h3>
<ul>
  <li>Focus on efficiency rather than raw speed.</li>
  <li>Save your powerups for the hardest levels.</li>
  <li>Stay calm during high-pressure moments.</li>
  <li>Consistency and planning always outperform rushed actions.</li>
</ul>`
  },
  {
    id: '2048',
    path: '/game/2048',
    title: '2048',
    developer: 'Eternally Games',
    category: 'Puzzle',
    tags: ['casual', 'puzzle'],
    thumbnail: '/thumbnails/2048.webp',
    span: '1x1',
    rating: '4.9 (22,040 votes)',
    gameplays: '5.9M',
    released: '2024',
    technology: 'HTML5',
    richTags: [
      { emoji: '🧩', text: 'Puzzle Games', url: '/categories' },
      { emoji: '🔥', text: 'Popular Games', url: '/categories' },
      { emoji: '📱', text: 'Mobile Ready', url: '/categories' }
    ],
    descriptionHtml: `
<p>Play 2048, a free puzzle game online where you challenge your mind and reflexes in an endless series of engaging levels. Experience beautiful graphics and smooth gameplay right in your browser!</p>
<p>Start your journey today, master the mechanics, and climb your way to the top. Whether you have 5 minutes or an hour, 2048 is perfectly paced to keep you entertained.</p>
<h3>How to Play 2048? 🎮</h3>
<ul>
  <li>Understand the basic mechanics introduced in the first level.</li>
  <li>Use your mouse or touch screen to interact with the game elements.</li>
  <li>Complete the primary objectives before time or moves run out.</li>
  <li>Earn high scores by stringing together combos and playing efficiently.</li>
</ul>
<h3>Gameplay Workflow and Mechanics ⏱️</h3>
<ul>
  <li>Fast reaction times and careful planning are both rewarded.</li>
  <li>Make sure to analyze the board before making your first move.</li>
  <li>Smooth coordination ensures you don't make easily avoidable mistakes.</li>
</ul>
<h3>Unlock and Upgrade 💰</h3>
<ul>
  <li>Collect coins and gems as you complete levels.</li>
  <li>Use your earnings to unlock new cosmetic themes and powerups.</li>
  <li>Daily challenges provide huge bonus rewards!</li>
</ul>
<h3>Strategy Tips for 2048 📈</h3>
<ul>
  <li>Focus on efficiency rather than raw speed.</li>
  <li>Save your powerups for the hardest levels.</li>
  <li>Stay calm during high-pressure moments.</li>
  <li>Consistency and planning always outperform rushed actions.</li>
</ul>`
  },
  {
    id: 'color_match',
    path: '/game/color-match',
    title: 'Color Match',
    developer: 'Eternally Games',
    category: 'Puzzle',
    tags: ['casual', 'puzzle'],
    thumbnail: '/thumbnails/color-match.webp',
    span: '1x1',
    rating: '4.7 (49,517 votes)',
    gameplays: '8.3M',
    released: '2024',
    technology: 'HTML5',
    richTags: [
      { emoji: '🧩', text: 'Puzzle Games', url: '/categories' },
      { emoji: '🔥', text: 'Popular Games', url: '/categories' },
      { emoji: '📱', text: 'Mobile Ready', url: '/categories' }
    ],
    descriptionHtml: `
<p>Play Color Match, a free puzzle game online where you challenge your mind and reflexes in an endless series of engaging levels. Experience beautiful graphics and smooth gameplay right in your browser!</p>
<p>Start your journey today, master the mechanics, and climb your way to the top. Whether you have 5 minutes or an hour, Color Match is perfectly paced to keep you entertained.</p>
<h3>How to Play Color Match? 🎮</h3>
<ul>
  <li>Understand the basic mechanics introduced in the first level.</li>
  <li>Use your mouse or touch screen to interact with the game elements.</li>
  <li>Complete the primary objectives before time or moves run out.</li>
  <li>Earn high scores by stringing together combos and playing efficiently.</li>
</ul>
<h3>Gameplay Workflow and Mechanics ⏱️</h3>
<ul>
  <li>Fast reaction times and careful planning are both rewarded.</li>
  <li>Make sure to analyze the board before making your first move.</li>
  <li>Smooth coordination ensures you don't make easily avoidable mistakes.</li>
</ul>
<h3>Unlock and Upgrade 💰</h3>
<ul>
  <li>Collect coins and gems as you complete levels.</li>
  <li>Use your earnings to unlock new cosmetic themes and powerups.</li>
  <li>Daily challenges provide huge bonus rewards!</li>
</ul>
<h3>Strategy Tips for Color Match 📈</h3>
<ul>
  <li>Focus on efficiency rather than raw speed.</li>
  <li>Save your powerups for the hardest levels.</li>
  <li>Stay calm during high-pressure moments.</li>
  <li>Consistency and planning always outperform rushed actions.</li>
</ul>`
  },
  {
    id: 'arrow_escape',
    path: '/game/arrow-escape',
    title: 'Arrow Escape',
    developer: 'Eternally Games',
    category: 'Puzzle',
    tags: ['puzzle', 'casual', 'brain'],
    thumbnail: '/thumbnails/arrow-escape.webp',
    span: '2x2',
    rating: '4.8 (12,402 votes)',
    gameplays: '4.2M',
    released: '2024',
    technology: 'HTML5',
    richTags: [
      { emoji: '🧩', text: 'Puzzle Games', url: '/categories' },
      { emoji: '🔥', text: 'Popular Games', url: '/categories' },
      { emoji: '📱', text: 'Mobile Ready', url: '/categories' }
    ],
    descriptionHtml: `
<p>Play Arrow Escape, a satisfying clearing puzzle where you tap arrows to fly them off the board!</p>
<p>Make sure they aren't blocked by other arrows. Plan your sequence carefully and clear the entire grid.</p>
<h3>How to Play Arrow Escape? 🎮</h3>
<ul>
  <li>Tap any arrow tile to make it fly in the direction it's pointing.</li>
  <li>An arrow can only escape if its path to the edge of the board is completely clear.</li>
  <li>If it hits another tile, it will bump and stay in place.</li>
  <li>Clear all tiles from the board to complete the level.</li>
</ul>`,
    faqs: [
      { question: "What happens if an arrow hits another?", answer: "It simply bumps and stays in place. You lose a move/time, and must clear the blocking tile first!" },
      { question: "Is Arrow Escape hard?", answer: "It starts easy, but later levels introduce complex interlocking patterns that require careful logic to untangle." }
    ]
  },
  {
    id: 'restaurant_merge_rush',
    path: '/game/restaurant-merge-rush',
    title: 'Restaurant Merge Rush',
    developer: 'Eternally Games',
    category: 'Simulation',
    tags: ['casual', 'simulation', 'business', 'merge'],
    thumbnail: '/thumbnails/restaurant-merge.webp',
    span: '2x2',
    rating: '5.0 (99,999 votes)',
    gameplays: '10.5M',
    released: '2024',
    technology: 'HTML5',
    richTags: [
      { emoji: '👨‍🍳', text: 'Restaurant', url: '/categories' },
      { emoji: '🔥', text: 'Trending', url: '/categories' },
      { emoji: '📱', text: 'Mobile Ready', url: '/categories' }
    ],
    descriptionHtml: `
<p>Run your own busy kitchen in Restaurant Merge Rush!</p>
<p>Spawn ingredients, merge them into complex meals, and serve customers to earn cash. Use your earnings to upgrade your kitchen counter space and unlock new recipes.</p>
<h3>How to Play Restaurant Merge Rush? 🎮</h3>
<ul>
  <li>Tap the SPAWN button to create raw ingredients.</li>
  <li>Drag matching ingredients together to merge them into better food.</li>
  <li>Drag the finished food to the customer order bubbles at the top of the screen to serve them and earn cash!</li>
  <li>Use cash in the Shop to buy upgrades.</li>
</ul>`,
    faqs: []
  },
  {
    id: 'emoji_drop_merge',
    path: '/game/emoji-drop-merge',
    title: 'Emoji Drop',
    developer: 'Eternally Games',
    category: 'Arcade',
    tags: ['casual', 'arcade', 'physics', 'merge'],
    thumbnail: '/thumbnails/emoji-drop.webp',
    span: '2x2',
    rating: '4.9 (15,221 votes)',
    gameplays: '3.1M',
    released: '2024',
    technology: 'HTML5',
    richTags: [
      { emoji: '🕹️', text: 'Arcade Games', url: '/categories' },
      { emoji: '🔥', text: 'Popular Games', url: '/categories' },
      { emoji: '📱', text: 'Mobile Ready', url: '/categories' }
    ],
    descriptionHtml: `
<p>Play Emoji Drop, the incredibly satisfying physics merging game!</p>
<p>Drop emojis into the bucket and watch them merge when two identical ones touch. Can you create the giant watermelon before the bucket overflows?</p>
<h3>How to Play Emoji Drop? 🎮</h3>
<ul>
  <li>Move the current emoji left or right at the top of the bucket.</li>
  <li>Click or tap to drop it in.</li>
  <li>Two identical emojis merge into a bigger, higher-tier emoji!</li>
  <li>Keep merging to clear space and rack up points. If an emoji crosses the red line, it's game over!</li>
</ul>`,
    faqs: []
  },
  {
    id: 'emoji_match',
    path: '/game/emoji-match',
    title: 'Emoji Match',
    developer: 'Eternally Games',
    category: 'Puzzle',
    tags: ['puzzle', 'casual', 'matching'],
    thumbnail: '/thumbnails/emoji-match.webp',
    span: '1x1',
    rating: '4.8 (8,402 votes)',
    gameplays: '1.2M',
    released: '2024',
    technology: 'HTML5',
    richTags: [
      { emoji: '🧩', text: 'Puzzle Games', url: '/categories' },
      { emoji: '✨', text: 'New Games', url: '/categories' }
    ],
    descriptionHtml: `
<p>Play Emoji Match, a fun and intuitive puzzle game where you connect related emojis by drawing lines between them!</p>
<p>Test your association skills and clear all the pairs to advance through increasingly difficult levels.</p>
<h3>How to Play Emoji Match? 🎮</h3>
<ul>
  <li>Drag a line from an emoji on the left to a related emoji on the right.</li>
  <li>If they match, the line will lock into place.</li>
  <li>Connect all pairs on the board to beat the level.</li>
</ul>`,
    faqs: []
  },
  {
    id: 'emoji_sort',
    path: '/game/emoji-sort',
    title: 'Emoji Sort',
    developer: 'Eternally Games',
    category: 'Puzzle',
    tags: ['puzzle', 'casual', 'sorting'],
    thumbnail: '/thumbnails/emoji-sort.webp',
    span: '2x2',
    rating: '4.8 (11,402 votes)',
    gameplays: '2.2M',
    released: '2024',
    technology: 'HTML5',
    richTags: [
      { emoji: '🧩', text: 'Puzzle Games', url: '/categories' },
      { emoji: '✨', text: 'New Games', url: '/categories' }
    ],
    descriptionHtml: `
<p>Play Emoji Sort, a fun and intuitive puzzle game where you sort emojis into test tubes!</p>
<p>Test your sorting skills and clear all the tubes to advance through increasingly difficult levels.</p>
<h3>How to Play Emoji Sort? 🎮</h3>
<ul>
  <li>Tap a tube to lift the top emojis.</li>
  <li>Tap another tube to pour them.</li>
  <li>You can only pour if the destination tube has enough space and the top emoji matches!</li>
  <li>Sort all emojis by type to complete the level.</li>
</ul>`,
    faqs: []
  },
  {
    id: 'cat-merge',
    path: '/game/cat-merge',
    title: 'Cat Merge',
    developer: 'Eternally Games',
    category: 'Puzzle',
    tags: ['casual', 'puzzle', 'merge'],
    thumbnail: '/assets/cat_room.webp',
    span: '2x2',
    description: 'Merge adorable cats and build your passive income in this cozy idle game!'
  },
  {
    id: 'neon_maze',
    path: '/game/neon-maze',
    title: 'Neon Maze',
    developer: 'Eternally Games',
    category: 'Arcade',
    tags: ['arcade', 'casual', 'maze'],
    thumbnail: '/assets/neon_maze.webp',
    span: '2x2',
    description: 'A modern neon sliding maze game.'
  },
  {
    id: 'flag-guess',
    path: '/game/flag-guess',
    title: 'Flag Guesser',
    developer: 'Eternally Games',
    category: 'Educational',
    tags: ['trivia', 'educational', 'flags'],
    thumbnail: '/thumbnails/flag-guess.webp',
    span: '2x2',
    description: 'Test your geography knowledge! Can you guess the flag?'
  }
];

export const getGameById = (id: string): GameMeta | undefined => {
  return gamesRegistry.find(game => game.id === id);
};

export const getSimilarGames = (category: string, currentId: string, limit = 6): GameMeta[] => {
  let similar = gamesRegistry.filter(game => game.category === category && game.id !== currentId);
  if (similar.length < limit) {
    const others = gamesRegistry.filter(game => game.category !== category && game.id !== currentId);
    similar = [...similar, ...others].slice(0, limit);
  }
  return similar.slice(0, limit);
};
